export const SKU = {
  connectMonthly: 'SUB101',
  connectAnnually: 'SUB141',
  connectOneYearFree: 'SUB212PP',
  connectForBusinessMonthly: 'SUB801',
  connectForBusinessAnnually: 'SUB841',
} as const;

export type SKU = (typeof SKU)[keyof typeof SKU];
